"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.HighlightGrid = exports.Highlight = exports.FourthColumn = exports.BottomContent = void 0;
var _mui = require("@ori-ui/mui");
var _personalMenu = require("@ori/personal-menu");
var _presentationUtils = require("@ori/presentation-utils");
var _styles = require("../../components/styles");
var _constants = require("../../constants");
// istanbul ignore file

const FourthColumn = exports.FourthColumn = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'block'
  }
}));
const Highlight = exports.Highlight = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  width: '100%',
  padding: theme.spacing(6, 3),
  backgroundColor: theme.palette.grey[100],
  marginBottom: theme.spacing(6)
}));
const BottomContent = exports.BottomContent = (0, _mui.styled)(_styles.MobileOfficeRoot)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(6),
  padding: theme.spacing(0, 3),
  [theme.breakpoints.up('sm')]: {
    padding: 0
  }
}));
const HighlightGrid = exports.HighlightGrid = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isMobileOffice,
  theme
}) => ({
  maxWidth: _constants.maxWidth,
  boxSizing: 'content-box',
  margin: '0 auto',
  display: 'grid',
  gridTemplateColumns: '1fr',
  columnGap: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '3fr 1fr'
  },
  ...(isMobileOffice && {
    [theme.breakpoints.up(_personalMenu.BREAKPOINT_HORIZONTAL_SIDEPANEL_LEGACY)]: {
      margin: theme.spacing(0, 6),
      borderLeft: '280px solid transparent'
    },
    [theme.breakpoints.up(1604)]: {
      margin: '0 auto',
      borderLeft: 'none'
    }
  })
}));
const Root = exports.Root = (0, _mui.styled)('footer')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginTop: theme.spacing(6),
  background: theme.palette.common.white,
  paddingBottom: theme.spacing(9)
}));
